import { render, staticRenderFns } from "./EventListView.vue?vue&type=template&id=1f67f0f1&scoped=true"
import script from "./EventListView.vue?vue&type=script&lang=js"
export * from "./EventListView.vue?vue&type=script&lang=js"
import style0 from "./EventListView.vue?vue&type=style&index=0&id=1f67f0f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67f0f1",
  null
  
)

export default component.exports